import { defineComponent as _defineComponent } from 'vue'
import { adminApiGetOrganisations } from '@/api/organisation';
  import { useToasted } from '@/helpers';
  import { Organisation } from '@/types/api/organisation';
  import { OrganisationContentCopy } from '@/types/widgets/copyContent';
  import { computed, onMounted, ref, watch } from 'vue';
  import Modal from '@/components/common/Modal.vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import Loader from '@/components/common/Loader.vue';
  import moment from 'moment';
  import { apiCopyContent } from '@/api/contentCopy';

  
  const __default__ = {
    name: 'CopyContentModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    contentType: {
      type: String,
      required: true,
    },
    contentId: {
      type: String,
      required: true,
    },
  },
  emits: ["closeModal"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'closeModal', value: void): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props;

  
  

  const toasted = useToasted();
  const searchText = ref<string | null>(null);
  const orgs = ref<Array<OrganisationContentCopy>>([]);
  const isLoading = ref<boolean>(false);
  const isSaving = ref(false);
  const selectedOrgs = ref<Array<OrganisationContentCopy>>([]);

  const filteredOrgs = computed(() => {
    if (!searchText.value) return orgs.value;

    return orgs.value.filter(
      (org) => org.name.toLowerCase().indexOf(searchText.value?.toLowerCase() as string) !== -1,
    );
  });

  watch(
    () => orgs.value.map((org) => org.isSelected),
    () => {
      selectedOrgs.value = orgs.value.filter((org) => org.isSelected);
    },
    { deep: true },
  );

  onMounted(async () => {
    isLoading.value = true;
    try {
      const response = await adminApiGetOrganisations();
      orgs.value = response.data.map((org: Organisation) => {
        return {
          ...org,
          isSelected: false,
        };
      });
    } catch (err) {
      console.log('Failed to get organisations');
    }
    isLoading.value = false;
  });

  function closeModal() {
    emits('closeModal');
  }

  function formatDate(value: string) {
    if (!value) return;
    const ts = moment.utc(value);
    return ts.local().format('D/MM/Y');
  }

  async function copyContent() {
    isSaving.value = false;
    try {
      await apiCopyContent(
        props.contentId,
        props.contentType,
        selectedOrgs.value.map((org) => org.organisation_id),
      );
      toasted.global.general_success({
        message: `Copying ${props.contentType} to selected organisations queued for processing`,
      });
      closeModal();
    } catch {
      toasted.global.general_error({
        message: `Error in copying ${props.contentType} to selected organisations`,
      });
    }
    isSaving.value = false;
  }

return { __sfc: true,props, emits, toasted, searchText, orgs, isLoading, isSaving, selectedOrgs, filteredOrgs, closeModal, formatDate, copyContent, Modal, BaseText, Loader }
}

})